import { useEffect, useRef, useState, useCallback } from 'react';
import { registerInViewVideo, setInViewVideoHovered } from '../util/inViewVideoController';

export function useInViewVideoPlayback({ id, enabled = true } = {}) {
    const [shouldPlay, setShouldPlay] = useState(false);
    const elementRef = useRef(null);

    useEffect(() => {
        if (!enabled || !id) {
            setShouldPlay(false);
            return undefined;
        }

        const element = elementRef.current;
        if (!element) return undefined;

        const unregister = registerInViewVideo(id, element, nextShouldPlay => {
            setShouldPlay(prev => (prev === nextShouldPlay ? prev : nextShouldPlay));
        });

        return () => {
            unregister();
            setShouldPlay(false);
        };
    }, [id, enabled]);

    const handleMouseEnter = useCallback(() => {
        if (!enabled || !id) return;
        setInViewVideoHovered(id, true);
    }, [id, enabled]);

    const handleMouseLeave = useCallback(() => {
        if (!enabled || !id) return;
        setInViewVideoHovered(id, false);
    }, [id, enabled]);

    return {
        elementRef,
        shouldPlay,
        handleMouseEnter,
        handleMouseLeave
    };
}
